import { useState } from "react";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import SecondaryRightIconSmallButton from "../../CommonButtons/SecondaryRightIconSmallButton";
import TextInputField from "../../CommonInputFields/TextInputField";

const GstDetails = ({
  gstVerified,
  beneVerifyGST,
  isGSTLoading,
  GSTLinked,
  GstNumber,
  setShowPopup,
  handleChange,
  previewMode = false,
  gst_org_name,
  gstin,
  type,
  isSwitchAccountLocked,
  isInputDisabled = false,
  isGstnPresent
}) => {
  const [focused, setFocused] = useState(false);



  if (previewMode) {
    return (
      <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
        <div className="flex flex-col gap-gap-md">
          <div className="text-text-primary text-font-md">
            <span className="font-semibold">GSTIN Details</span>
            <span className="font-normal"> {isGstnPresent ? "" :"(Optional)"}</span>
          </div>

          <div className="flex flex-col gap-gap-sm">
            <div className="flex flex-col gap-gap-xs">
              <div className="w-width-full overflow-hidden truncate text-text-primary font-normal text-font-md">
                {gstin ? <span>{gstin}</span> : <span>Not given</span>}
              </div>
              <div className="text-font-xs font-normal text-text-secondary">
                GSTIN
              </div>
            </div>
            {gstin ? (
              <>
                <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
                <div className="flex flex-col gap-gap-xs">
                  <div className="w-width-full overflow-hidden text-wrap text-text-primary font-normal text-font-md">
                    {gstin ? gst_org_name : null}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    {gstin ? "Company name" : null}
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    );
  }



  return (
    <div
      className={`flex flex-col relative rounded-border-radius-md mt-margin-md`}
    >
      <div className="h-height-full flex flex-col rounded-border-radius-md relative z-z-index-header">
        <div
          className={`absolute w-width-full py-padding-md bg-primary-card bottom-bottom-base transition-transform duration-animation-fast-s ease-in-out transform ${
            ((!isGSTLoading && beneVerifyGST?.status) ||
              beneVerifyGST?.status === false) &&
            GstNumber?.length === GlobalConfiguration.gstLength
              ? "opacity-base-opacity rounded-b-none"
              : "opacity-opacity-none rounded-b-border-radius-md"
          }`}
          style={{
            backgroundColor:
              !isGSTLoading &&
              gstVerified &&
              GstNumber?.length === GlobalConfiguration.gstLength
                ? "var(--positive-card)"
                : !isGSTLoading &&
                    gstVerified === false &&
                    GstNumber?.length === GlobalConfiguration.gstLength
                  ? "var(--negative-card)"
                  : "transparent",
          }}
        ></div>
        <div className="w-width-full flex flex-col bg-primary-card rounded-border-radius-md p-padding-md gap-gap-md relative">
          <div className="w-width-full flex flex-col gap-gap-md">
            <div className="text-text-primary text-base">
              <span className="font-semibold">GSTIN Details</span>
              <span className="font-normal"> {isGstnPresent ? "" :"(Optional)"}</span>
            </div>

            <div className="w-width-full flex flex-row items-center self-center text-center gap-gap-button-l">
              <TextInputField
                variant={
                  isGSTLoading
                    ? "typing"
                    : beneVerifyGST?.status &&
                        GSTLinked &&
                        GstNumber?.length === GlobalConfiguration.gstLength
                      ? "verified"
                      : GstNumber?.length === GlobalConfiguration.gstLength
                        ? gstVerified === false
                          ? "error"
                          : "typing"
                        : focused
                          ? "typing"
                          : "default"
                }
                placeholder="GSTIN"
                bgColor="var(--primary-card)"
                fgColor="var(--text-primary)"
                value={GstNumber}
                name="gstin"
                onInput={handleChange}
                isFullWidth={true}
                onFocus={(e) => setFocused(true)}
                onBlur={(e) => setFocused(false)}
                isDisabled={isSwitchAccountLocked || isInputDisabled}
                adornment={isGSTLoading ? ICONS?.LOADER_GIF : undefined}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className={`transition-transform duration-animation-fast ease-in-out transform ${
          (!isGSTLoading && gstVerified) || (!isGSTLoading && !gstVerified)
            ? "translate-y-0 opacity-base-opacity"
            : "-translate-y-full opacity-opacity-none"
        }`}
      >
        {beneVerifyGST?.status &&
        !isGSTLoading &&
        GSTLinked &&
        GstNumber?.length === GlobalConfiguration.gstLength ? (
          <div className="h-height-full px-padding-md py-padding-md flex flex-col rounded-b-border-radius-md bg-positive-card">
            {gstVerified === true ? (
              <div>
                <div className="flex justify-between items-center">
                  <div className="flex justify-between items-start">
                    <img
                      className="h-icon-md mr-margin-sm mt-margin-xs"
                      src={ICONS?.VERIFIED_WITH_WHITE_CIRCLE_GREEN}
                      alt="check"
                    />
                    <div className="flex flex-col gap-gap-xs">
                      <div className="text-text-primary">
                        {beneVerifyGST?.gstin_details?.business_name}
                      </div>
                      <div className="text-text-secondary text-left text-font-xs font-normal">
                        Company name
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {gstVerified === true ? (
              <div className="flex items-center justify-end mt-margin-sm">
                <SecondaryRightIconSmallButton
                  btnText="View details"
                  handleFunction={() => {
                    if (isSwitchAccountLocked) return;
                    setShowPopup(true);
                  }}
                  icon={ICONS?.ARROW_RIGHT_WHITE}
                  enabledBgColor="var(--text-primary)"
                  enabledTextColor="var(--primary-bg)"
                  imgColor="var(--primary-bg)"
                  isDisabled={isSwitchAccountLocked}
                />
              </div>
            ) : null}
          </div>
        ) : beneVerifyGST?.status &&
          !isGSTLoading &&
          !GSTLinked &&
          GstNumber?.length === GlobalConfiguration.gstLength ? (
          <div>
            {gstVerified === false && (
              <div className="px-padding-md py-padding-md rounded-b-border-radius-md bg-negative-card">
                <div className="flex text-text-primary items-start">
                  <img
                    className="h-icon-md mr-margin-sm mt-margin-xs"
                    src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                    alt="verified logo"
                  />
                  <div className="flex flex-col gap-gap-xs">
                    <div className="text-text-primary">
                      {"GSTIN is not linked."}
                    </div>
                    <div className="text-font-xs text-text-primary font-normal">
                      To proceed either enter a valid GSTIN associated with
                      the PAN above or clear the field of GSTIN details.
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <></>
        )}
        {!beneVerifyGST?.status &&
          !isGSTLoading &&
          GstNumber?.length === GlobalConfiguration.gstLength && (
            <div>
              {gstVerified === false && (
                <div className="px-padding-md py-padding-md rounded-b-border-radius-md bg-negative-card">
                  <div className="flex text-text-primary items-start">
                    <img
                      className="h-icon-md mr-margin-sm mt-margin-xs"
                      src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                      alt="verified logo"
                    />
                    <div className="flex flex-col gap-gap-xs">
                      <div className="text-text-primary">
                        GSTIN is invalid
                      </div>
                      <div className="text-font-xs text-text-primary font-normal">
                        To proceed either enter a valid GSTIN associated
                        with the PAN above or clear the field of GSTIN details.
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

export default GstDetails;
